
import { Contact } from "@/models/base";
import { ContactAddress } from "@/models/base";
import Vue from "vue";
import AppContactSearch from "./ContactSearch.vue";
import AppCustomerBrowse from "./CustomerSearchBrowse.vue";
import AppSupplierBrowse from "./SupplierSearchBrowse.vue";
import AppProspectBrowse from "./ProspectSearchBrowse.vue";
import AppAllContactsBrowse from "./AllContactsBrowse.vue";
import { UserConfigService } from "../../services/user-config-service";

export default Vue.extend({
	data() {
		return {
			searchModal: false,
			createModal: false,
			newContact: new Contact(),
			selectedGroupId: 0,
			selectGroupModalOpen: false
		};
	},
	props: {
		groupId: {
			type: [Number, Array as () => number[]],
			required: true
		},
		value: {
			type: Object as () => Contact
		},
		label: {
			type: String
		},
		fancy: {
			type: Boolean
		},
		disableCreate: Boolean,
		disabled: Boolean,
		iconLeft: String,
		iconLeftTooltip: [String, Object],
	},
	computed: {
		searchButtonSize(): number {
			if (this.disableCreate) {
				return 12;
			}
			return 6;
		},
		canCreate(): boolean {
			return this.createableContactGroups.length > 0;
		},
		computedGroupIds(): number[] {
			if (typeof (this.groupId) == "object") {
				return this.groupId.filter(id => UserConfigService.hasCurrentUserPermission((p) => p.getPermissionsByBrowseID(id).CanRead));
			}
			return [this.groupId];
		},
		createableContactGroups(): number[] {
			return this.computedGroupIds.filter(id => UserConfigService.hasCurrentUserPermission((p) => p.getPermissionsByBrowseID(id).hasWritePermissions()));
		},
	},
	watch: {
		"newContact.ID"(id: number) {
			if (id != 0) {
				this.$emit("input", this.newContact);
				this.createModal = false;
			}
		},
	},
	methods: {
		focus() {
			(this.$refs.input as any).focus();
		},
		blur() {
			(this.$refs.input as any).blur();
		},
		onBlur() {
			this.$emit("blur");
		},
		onFocus() {
			this.$emit("focus");
		},
		onInput(contact: Contact) {
			this.$emit("input", contact);
		},
		getGroupId(groupId:number | number[]):number {
			if (typeof(groupId) == "number") {
				return groupId;
			}
			return groupId[0];
		},
		openNewContactModal(groupId?: number | number[]) {
			if (groupId == undefined) {
				let groups = this.createableContactGroups;
				if (groups.length == 1) {
					groupId = groups[0];
				} else {
					this.selectGroupModalOpen = true;
					return;
				}
			}
			this.newContact = new Contact();
			this.newContact.MainAddress = new ContactAddress();
			this.newContact.MainAddress.IsMainAddress = true;
			this.newContact.Addresses = [this.newContact.MainAddress as ContactAddress];
			this.newContact.GroupID = this.getGroupId(groupId);
			this.createModal = true;
			this.selectGroupModalOpen = false;
		},
		openBrowseModal(groupId: number | number[]) {
			console.trace("Opening browse modal");
			this.selectedGroupId = this.getGroupId(groupId);
			this.searchModal = true;
		},
		onBrowseItemSelected(item: Contact) {
			this.$emit("input", item);
			this.searchModal = false;
		},
		iconLeftClick(){
			this.$emit("icon-left-click");
		}
	},
	components: {
		AppContactSearch,
		AppCustomerBrowse,
		AppSupplierBrowse,
		AppProspectBrowse,
		AppAllContactsBrowse
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
